/** Format the collected widget texts into the content sent for summarization, skipping the empty ones */
export const formatTextToSummarize = (texts: string[]) =>
    texts
        .map((text, index) => (text ? `\n\n #### Piece of content number ${index + 1}: ${text}` : ''))
        .join('')
        .trim();
